
import React from "react";
import moment from "moment-timezone";
import { Nav, Row, Col, Card, OverlayTrigger, Tooltip, Image, Button } from '@themesberg/react-bootstrap';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCogs, faDownload } from "@fortawesome/free-solid-svg-icons";
import BS5Logo from "../assets/img/technologies/bootstrap-5-logo.svg";
import ReactLogo from "../assets/img/technologies/react-logo.svg";
import LaravelLogo from "../assets/img/technologies/laravel-logo.svg";
import GitHubButton from 'react-github-btn';
import { Routes } from "../routes";
import {Link} from 'react-router-dom';


export default (props) => {
  const currentYear = moment().get("year");
  const showSettings = props.showSettings;

  const toggleSettings = (toggle) => {
    props.toggleSettings(toggle);
  }

  return (
    <div>
      <footer className="footer section py-5">
        <Row>
          <div className="container">
            <div className="row row-cols-auto">
              <div className="col"><p className="mb-0 text-center text-xl-left">Copyright © {`${currentYear} `} Rupine Labs GmbH</p></div>
              <div className="col"><Link to={Routes.Impressum.path}>Impressum</Link></div>
              <div className="col"><Link to={Routes.PrivacyPolicy.path}>PrivacyPolicy</Link></div>
            </div>
          </div>
        </Row>
      </footer>
    </div>
  );
};
